module.exports = __webpack_public_path__ + "img/Identification-and-authentication-1.11a43840.png";